export const QUESTION_GIVEAWAY_RESET = 'QUESTION_GIVEAWAY_RESET';
export const QUESTION_GIVEAWAY_SUCCESS = 'QUESTION_GIVEAWAY_SUCCESS';

export const CONTACT_FORM_RESET = 'CONTACT_FORM_RESET';



// WEBPACK FOOTER //
// ./src/store/modules/app/mutation-types.js